export { default as ContactTestimonialsWithQuery } from './contact-testimonials-with-query';
export { default as ContactTestimonialsWithFragment } from './contact-testimonials-with-fragment';
